import { render, staticRenderFns } from "./SurveyChart.vue?vue&type=template&id=65a320a2&scoped=true&"
import script from "./SurveyChart.vue?vue&type=script&lang=js&"
export * from "./SurveyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a320a2",
  null
  
)

export default component.exports